import React, { useState, useEffect, useRef } from "react";
import Layout from "./Layout";
import "../assets/css/ReporteGeneral.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faArrowRotateLeft,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import ReactPaginate from "react-paginate";
import {
  getUpdateData,
  getDailyReport,
  updateReportAPI,
  getCurrentUser,
  createSugerencia,
  processReportsAPI,
  getLastReportDateAPI,
} from "../services/API";
import { segmentationCSTsByModeNegativization } from "../services/NegativizationService";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/default.css";
import socket from "../assets/js/socket";
import axios from "axios";
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import ProductInfo from "./ProductInfo";

const constapiUrl = process.env.REACT_APP_API_URL || "http://localhost:4000";

const GeneralReportPage = () => {
  const [isProductInfoActive, setIsProductInfoActive] = useState(false);
  const allLoadedData = useRef([]);
  const [dataAdgroups, setDataAdgroups] = useState([]);
  const [dataCampaign, setDataCampaign] = useState([]);
  const [dataPortfolios, setDataPortfolios] = useState([]);
  const [dataProductos, setDataProductos] = useState([]);
  const [selectedNegativeOption, setSelectedNegativeOption] = useState("");
  const [copiesRealTime, setCopiesRealTime] = useState({});
  const [temporaryCheckboxes, setTemporaryCheckboxes] = useState({
    SP: {},
    SB: {},
  });
  const [selectedTypeId, setSelectedTypeId] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [filtrosAplicados, setFiltrosAplicados] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [activeSubmenuFilter, setActiveSubmenuFilter] = useState({
    type: "ALL",
    value: null,
  });
  const [submenuSearchValue, setSubmenuSearchValue] = useState("");
  const [currentMultipleSelection, setCurrentMultipleSelection] = useState([]);
  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [isRange, setIsRange] = useState(false);
  const [amazonProductsCache, setAmazonProductsCache] = useState({});

  const extractAsin = (text) => {
    if (!text || typeof text !== "string") return null;
    const match = text.toUpperCase().match(/\b(B[0-9A-Z]{9})\b/);
    return match ? match[0] : null;
  };

  const getEffectiveAsin = React.useCallback((item) => {
    let found = extractAsin(item.searchTerm);
    if (found) return found;

    const targetingText = item.keyword || item.keywordText;
    found = extractAsin(targetingText);
    if (found) return found;

    found = extractAsin(item.asin);
    if (found) return found;

    return null;
  }, []);

  const fetchAmazonProductData = React.useCallback(async (data) => {
    const asinsInCache = new Set(Object.keys(amazonProductsCache));
    const uniqueAsinsToFetch = [
      ...new Set(
        data
          .map((item) => getEffectiveAsin(item))
          .filter((asin) => asin && !asinsInCache.has(asin)),
      ),
    ];

    if (uniqueAsinsToFetch.length === 0) {
      console.log(
        "All required ASINs are already cached or no valid ASINs were found.",
      );
      return;
    }
    console.log(
      `Requesting data for ${uniqueAsinsToFetch.length} products from backend...`,
    );

    try {
      const response = await axios.post(`${constapiUrl}/amazon/products`, {
        asins: uniqueAsinsToFetch,
      });
      if (response.data) {
        setAmazonProductsCache((prevCache) => {
          const newCache = { ...prevCache, ...response.data };
          // Mark failed ASINs so we don't retry them infinitely
          uniqueAsinsToFetch.forEach((asin) => {
            if (!(asin in newCache)) {
              newCache[asin] = { _failed: true };
            }
          });
          return newCache;
        });
      }
    } catch (error) {
      console.error(
        "Error fetching product data from backend:",
        error,
      );
      alertify.notify(
        "Could not connect to the product service.",
        "error",
        7,
      );
    }
  }, [amazonProductsCache, getEffectiveAsin]);

  const getYesterdayDate = () => {
    let day = moment().subtract(1, "days").format("YYYY-MM-DD");
    return day;
  };

  const [showReprocessModal, setShowReprocessModal] = useState(false);
  const [reprocessType, setReprocessType] = useState("partial");
  const [reprocessDate, setReprocessDate] = useState(getYesterdayDate());

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const getCurrentTypeKey = () => (selectedTypeId === 1 ? "SP" : "SB");

  const handleApplyFilter = () => {
    setShowModal(false);
    if (
      modalTitle === "Section" ||
      modalTitle === "Match Type" ||
      modalTitle === "Portfolio"
    ) {
      setFiltrosAplicados((prev) => ({
        ...prev,
        [modalTitle]: currentMultipleSelection,
      }));
      setCurrentMultipleSelection([]);
    } else {
      setFiltrosAplicados((prev) => ({
        ...prev,
        [modalTitle]: selectedOption,
      }));
    }
    setSelectedOption(null);
  };

  const handleApplyTextFilter = () => {
    setShowTextFilterModal(false);
    setFiltrosAplicados((prev) => ({
      ...prev,
      [modalTitle]: {
        option: selectedTextFilterOption,
        value: textFilterValue,
      },
    }));
    setTextFilterValue("");
  };

  const handleApplyNumberFilter = () => {
    setShowNumberFilterModal(false);
    setFiltrosAplicados((prev) => ({
      ...prev,
      [modalTitle]: {
        option: selectedNumberFilterOption,
        value: parseFloat(numberFilterValue),
      },
    }));
    setNumberFilterValue(null);
  };

  const getNestedValue = (obj, path) =>
    path.split(".").reduce((acc, part) => acc && acc[part], obj) || "";

  const datosFiltrados = (data, filtrosAplicados) => {
    return data.filter((item) => {
      let matchFilter = true;
      let seccionFilter = true;
      let portfolioFilter = true;
      let texto = true;
      let numero = true;

      for (const key in filtrosAplicados) {
        const filterValue = filtrosAplicados[key];

        if (key === "Match_Type") {
          if (Array.isArray(filterValue) && filterValue.length > 0) {
            matchFilter = filterValue.includes(item?.keywordType || "");
          }
        } else if (key === "Section") {
          if (Array.isArray(filterValue) && filterValue.length > 0) {
            seccionFilter = filterValue.includes(item?.section?.sectionName || "");
          }
        } else if (key === "Portfolio") {
          if (Array.isArray(filterValue) && filterValue.length > 0) {
            const itemPortfolioName =
              item?.portfolio?.portfolioName || "No portfolio";
            portfolioFilter = filterValue.includes(itemPortfolioName);
          }
        } else if (
          ["ASIN", "Campaign", "adGroup", "Targeting", "CST"].includes(key)
        ) {
          if (
            filterValue &&
            typeof filterValue === "object" &&
            filterValue.hasOwnProperty("option") &&
            filterValue.hasOwnProperty("value")
          ) {
            const campos = {
              ASIN: item?.asin || "No ASIN",
              Campaign: item?.campaign?.campaignName || "No campaign",
              adGroup: item?.adGroup?.adGroupName || "No adGroup",
              Targeting: item?.keyword || item?.keywordText || "",
              CST: item?.searchTerm || "",
            };
            const itemValue = String(campos[key] || "")
              .toLowerCase()
              .replaceAll("_", " ")
              .trim();
            const filterText = String(filterValue.value || "")
              .toLowerCase()
              .trim();

            if (filterText === "") {
              continue;
            }

            switch (filterValue.option) {
              case "Contains":
                texto = texto && itemValue.includes(filterText);
                break;
              case "No Contains":
                texto = texto && !itemValue.includes(filterText);
                break;
              case "Equals":
                texto = texto && itemValue === filterText;
                break;
              case "Does Not Equal":
                texto = texto && itemValue !== filterText;
                break;
              case "Starts with":
                texto = texto && itemValue.startsWith(filterText);
                break;
              case "Ends with":
                texto = texto && itemValue.endsWith(filterText);
                break;
              default:
                break;
            }
          }
        } else if (
          [
            "Impresiones",
            "Clicks",
            "Cost Click",
            "Spend",
            "Sale 7D",
            "Units Sold",
            "CTR",
            "ACOS",
            "ROAS",
          ].includes(key)
        ) {
          if (
            filterValue &&
            typeof filterValue === "object" &&
            filterValue.hasOwnProperty("option") &&
            filterValue.value !== null &&
            filterValue.value !== undefined &&
            filterValue.value !== ""
          ) {
            const campos = {
              Impressions: item.impressions,
              Clicks: item.clicks,
              "Cost Click": item.costPerClick,
              Spend: item.cost || 0,
              "7D Sales": item.sales7d || 0,
              "Units Sold": item.unitsSoldClicks7d || 0,
              CTR: item.clickThroughRate || 0,
              ACOS: item.acosClicks7d || 0,
              ROAS: item.roasClicks7d || 0,
            };
            const itemValue = Number(campos[key]);
            const filterNumber = filterValue.value;

            switch (filterValue.option) {
              case "Greater than":
                numero = numero && itemValue > filterNumber;
                break;
              case "Equal to":
                numero = numero && itemValue === filterNumber;
                break;
              case "Less than":
                numero = numero && itemValue < filterNumber;
                break;
              default:
                break;
            }
          }
        }
      }

      const isSeccionFilterActive =
        Array.isArray(filtrosAplicados["Section"]) &&
        filtrosAplicados["Section"].length > 0;
      const isMatchFilterActive =
        Array.isArray(filtrosAplicados["Match Type"]) &&
        filtrosAplicados["Match Type"].length > 0;
      const isPortfolioFilterActive =
        Array.isArray(filtrosAplicados["Portfolio"]) &&
        filtrosAplicados["Portfolio"].length > 0;

      return (
        (isMatchFilterActive ? matchFilter : true) &&
        (isSeccionFilterActive ? seccionFilter : true) &&
        (isPortfolioFilterActive ? portfolioFilter : true) &&
        texto &&
        numero
      );
    });
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc")
      direction = "desc";
    setSortConfig({ key, direction });
    setCurrentPage(0);
  };

  const handleFilterClick = (filtro) => {
    if (filtro === "ALL") {
      setActiveSubmenuFilter({ type: "ALL", value: null });
    } else if (filtro === "SP" || filtro === "SB") {
      if (selectedNegativeOption === "Campaign") {
        setActiveSubmenuFilter({ type: "CAMPAIGN_TYPE", value: filtro });
      } else {
        setActiveSubmenuFilter({ type: "ALL", value: null });
      }
    } else if (filtro === "ENABLED" || filtro === "PAUSED") {
      setActiveSubmenuFilter({ type: "STATE", value: filtro });
    }
  };

  const [isEditingCST] = useState(true);
  const [editedCSTs, setEditedCSTs] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [copyData, setCopyData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isNegativeMode, setIsNegativeMode] = useState(false);
  const [isViewCSTMode, setIsViewCSTMode] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [selectedModalidad, setSelectedModalidad] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemToRemove, setItemToRemove] = useState(null);
  const [originalColumns, setOriginalColumns] = useState([]);
  const [showNegativeOptions, setShowNegativeOptions] = useState(false);
  const [selectedButton, setSelectedButton] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [savedCheckboxes, setSavedCheckboxes] = useState({ SP: {}, SB: {} });
  const [selectedModalidadValue, setSelectedModalidadValue] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const offset = currentPage * itemsPerPage;
  const currentData = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const [currentCST, setCurrentCST] = useState(null);
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [selectedColor, setSelectedColor] = useState("");

  const opcionesModal = {
    "Section": ["RISK", "NEUTRAL", "SECURE"],
    "Match Type": ["EXACT", "PHRASE", "BROAD"],
  };

  const textFilterOptions = [
    "Contains",
    "No Contains",
    "Equals",
    "Does Not Equal",
    "Starts with",
    "Ends with",
  ];

  const numberFilterOptions = ["Greater than", "Equal to", "Less than"];

  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalOptions, setModalOptions] = useState([]);
  const [showTextFilterModal, setShowTextFilterModal] = useState(false);
  const [selectedTextFilterOption, setSelectedTextFilterOption] =
    useState("Contains");
  const [textFilterValue, setTextFilterValue] = useState("");
  const [showNumberFilterModal, setShowNumberFilterModal] = useState(false);
  const [selectedNumberFilterOption, setSelectedNumberFilterOption] =
    useState("Greater than");
  const [numberFilterValue, setNumberFilterValue] = useState("");

  const handleSelectChange = (selected) => {
    const columna = selected.value;

    if (opcionesModal[columna]) {
      setModalTitle(columna);
      setModalOptions(opcionesModal[columna]);
      setCurrentMultipleSelection(filtrosAplicados[columna] || []);
      setShowModal(true);
    } else if (columna === "Portfolio") {
      setModalTitle(columna);
      const uniquePortfolios = [
        ...new Set(
          tableData
            .map((item) => item?.portfolio?.portfolioName || "No portfolio")
            .filter((name) => name),
        ),
      ].sort();

      setModalOptions(uniquePortfolios);
      setCurrentMultipleSelection(filtrosAplicados[columna] || []);
      setShowModal(true);
    } else if (
      ["ASIN", "Campaign", "adGroup", "Targeting", "CST"].includes(columna)
    ) {
      setModalTitle(columna);
      const currentFilter = filtrosAplicados[columna] || {};
      setSelectedTextFilterOption(currentFilter.option || "Contains");
      setTextFilterValue(currentFilter.value || "");
      setShowTextFilterModal(true);
    } else if (
      [
        "Impressions",
        "Clicks",
        "Cost Click",
        "Spend",
        "7D Sales",
        "Units Sold",
        "CTR",
        "ACOS",
        "ROAS",
      ].includes(columna)
    ) {
      setModalTitle(columna);
      const currentFilter = filtrosAplicados[columna] || {};
      setSelectedNumberFilterOption(currentFilter.option || "Greater than");
      setNumberFilterValue(
        currentFilter.value === undefined ? "" : currentFilter.value,
      );
      setShowNumberFilterModal(true);
    }
  };

  const handleMultiSelectChange = (optionValue) => {
    setCurrentMultipleSelection((prev) =>
      prev.includes(optionValue) ? prev.filter((item) => item !== optionValue) : [...prev, optionValue],
    );
  };

  useEffect(() => {
    if (isProductInfoActive && tableData.length > 0) {
      console.log("Product Info enabled. Fetching product data...");
      fetchAmazonProductData(tableData);
    }
  }, [isProductInfoActive, tableData, fetchAmazonProductData]);

  const generarDestiny = (data, modalidad, item, numero) => {
    if ([2, 5, 8, 11].includes(modalidad)) {
      data.destinations = null;
      return "";
    }
    if ([3, 6, 9, 12].includes(modalidad)) {
      const selected = selectedCheckboxes[numero];
      if (!selected || Object.keys(selected).length === 0)
        return "No destination selected for some CSTs.";
      const idsSelectdos = Object.keys(selected).filter(
        (id) => selected[id],
      );
      if (idsSelectdos.length === 0)
        return "No destination selected for some CSTs.";
      const portafolios = copiesRealTime.portafolios;
      const campanas = copiesRealTime.campaigns;
      const dataProductos = copiesRealTime.productos;
      switch (modalidad) {
        case 3:
          const campaignsFormateadas = [];
          for (const campaign of campanas) {
            const adGroupsFiltrados = campaign.adGroups.filter((ad) =>
              idsSelectdos.includes(ad.adGroupId),
            );
            if (adGroupsFiltrados && adGroupsFiltrados.length > 0) {
              campaignsFormateadas.push({
                campaignId: campaign.campaignId,
                campaignName: campaign.name,
                type:
                  campaign.type === "SP" ? "Sponsored Products" : campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                adGroups: adGroupsFiltrados.map((ad) => ({
                  adGroupId: ad.adGroupId,
                  adGroupName: ad.name,
                })),
              });
            }
          }
          data.destinations = { campaigns: campaignsFormateadas };
          break;
        case 6:
          const campaignsSelectdas = [];
          for (const campaign of campanas) {
            if (idsSelectdos.includes(campaign.campaignId)) {
              campaignsSelectdas.push({
                campaignId: campaign.campaignId,
                campaignName: campaign.name,
                type:
                  campaign.type === "SP" ? "Sponsored Products" : campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                adGroups:
                  campaign.adGroups.map((ad) => ({
                    adGroupId: ad.adGroupId,
                    adGroupName: ad.name,
                  })) || [],
              });
            }
          }
          data.destinations = { campaigns: campaignsSelectdas };
          break;
        case 9:
          const portfoliosFormateados = [];
          for (const portfolio of portafolios) {
            if (idsSelectdos.includes(portfolio.portfolioId)) {
              const campaignsFormateadas = campanas
                .filter(
                  (campaign) => campaign.portfolioId === portfolio.portfolioId,
                )
                .map((campaign) => ({
                  campaignId: campaign.campaignId,
                  campaignName: campaign.name,
                  Type:
                    campaign.type === "SP" ? "Sponsored Products" : campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                  adGroups: (campaign.adGroups || []).map((ad) => ({
                    adGroupId: ad.adGroupId,
                    adGroupName: ad.name,
                  })),
                }));
              portfoliosFormateados.push({
                portfolioId: portfolio.portfolioId,
                portfolioName: portfolio.name,
                campaigns: campaignsFormateadas,
              });
            }
          }
          data.destinations = { portfolios: portfoliosFormateados };
          break;
        case 12:
          const productosFormateados = [];
          for (const producto of dataProductos) {
            if (idsSelectdos.includes(producto.adId)) {
              const campaign = campanas.find(
                (c) => c.campaignId === producto.campaignId,
              );
              const adGroup = campaign.adGroups.find(
                (ad) => ad.adGroupId === producto.adGroupId,
              );
              const campaignFormateada = campaign
                ? {
                    campaignId: campaign.campaignId,
                    campaignName: campaign.name,
                    type:
                      campaign.type === "SP" ? "Sponsored Products" : campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                    adGroups: adGroup
                      ? [
                          {
                            adGroupId: adGroup.adGroupId,
                            adGroupName: adGroup.name,
                          },
                        ] : [],
                  }
                : null;
              productosFormateados.push({
                asin: producto.asin,
                sku: producto.sku,
                state: producto.state,
                campaigns: campaignFormateada ? [campaignFormateada] : [],
              });
            }
          }
          data.destinations = { asins: productosFormateados };
          break;
        default:
          break;
      }
      return "";
    }

    if (modalidad === 1) {
      if (item.adGroup) {
        data.destinations = { adGroup: item.adGroup };
        return "";
      } else return "One item has no valid ad group.";
    } else if (modalidad === 4) {
      if (item.campaign) {
        data.destinations = { campaign: item.campaign };
        return "";
      } else return "One item has no valid campaign.";
    } else if (modalidad === 7) {
      if (item.portfolio) {
        data.destinations = { portfolio: item.portfolio };
        return "";
      } else return "One item has no valid portfolio.";
    } else if (modalidad === 10) {
      if (item.asin) {
        data.destinations = { asin: item.asin };
        return "";
      } else return "One item has no valid ASIN.";
    }

    return `Modality ${modalidad} not supported for one of the items.`;
  };

  useEffect(() => {
    if (
      !copiesRealTime ||
      Object.keys(copiesRealTime).length === 0 ||
      !selectedNegativeOption
    ) {
      setDataAdgroups([]);
      setDataCampaign([]);
      setDataPortfolios([]);
      setDataProductos([]);
      return;
    }

    let baseDataForSubmenu;
    switch (selectedNegativeOption) {
      case "Adgroup":
        baseDataForSubmenu = copiesRealTime.adgroups ? [...copiesRealTime.adgroups] : [];
        break;
      case "Campaign":
        baseDataForSubmenu = copiesRealTime.campaigns ? [...copiesRealTime.campaigns] : [];
        break;
      case "Portfolio":
        baseDataForSubmenu = copiesRealTime.portafolios ? [...copiesRealTime.portafolios] : [];
        break;
      case "ASIN":
        baseDataForSubmenu = copiesRealTime.productos ? [...copiesRealTime.productos] : [];
        break;
      default:
        baseDataForSubmenu = [];
    }

    let filteredByDropdown = baseDataForSubmenu;

    if (
      activeSubmenuFilter.type === "CAMPAIGN_TYPE" &&
      selectedNegativeOption === "Campaign"
    ) {
      filteredByDropdown = baseDataForSubmenu.filter(
        (campaign) => campaign.type === activeSubmenuFilter.value,
      );
    } else if (activeSubmenuFilter.type === "STATE") {
      if (selectedNegativeOption === "Adgroup") {
        filteredByDropdown = baseDataForSubmenu
          .map((campaign) => ({
            ...campaign,
            adGroups: campaign.adGroups.filter(
              (adgroup) => adgroup.state === activeSubmenuFilter.value,
            ),
          }))
          .filter((campaign) => campaign.adGroups.length > 0);
      } else if (
        selectedNegativeOption === "Campaign" ||
        selectedNegativeOption === "Portfolio"
      ) {
        filteredByDropdown = baseDataForSubmenu.filter(
          (item) => item.state === activeSubmenuFilter.value,
        );
      } else if (selectedNegativeOption === "ASIN") {
        if (activeSubmenuFilter.value) {
          alertify.notify(
            "ASINs do not have a direct ENABLED or PAUSED status filter in this view.",
            "warning",
            5,
          );
        }
      }
    }

    let finalFilteredDataForSubmenu = filteredByDropdown;

    if (submenuSearchValue.trim() !== "") {
      const searchTermLower = submenuSearchValue.toLowerCase();
      if (selectedNegativeOption === "Adgroup") {
        finalFilteredDataForSubmenu = filteredByDropdown
          .map((campaign) => ({
            ...campaign,
            adGroups: campaign.adGroups.filter((adgroup) =>
              adgroup.name.toLowerCase().includes(searchTermLower),
            ),
          }))
          .filter((campaign) => campaign.adGroups.length > 0);
      } else if (
        selectedNegativeOption === "Campaign" ||
        selectedNegativeOption === "Portfolio"
      ) {
        finalFilteredDataForSubmenu = filteredByDropdown.filter((item) =>
          item.name.toLowerCase().includes(searchTermLower),
        );
      } else if (selectedNegativeOption === "ASIN") {
        finalFilteredDataForSubmenu = filteredByDropdown.filter(
          (item) =>
            item.asin && item.asin.toLowerCase().includes(searchTermLower),
        );
      }
    }

    switch (selectedNegativeOption) {
      case "Adgroup":
        setDataAdgroups(finalFilteredDataForSubmenu);
        break;
      case "Campaign":
        setDataCampaign(finalFilteredDataForSubmenu);
        break;
      case "Portfolio":
        setDataPortfolios(finalFilteredDataForSubmenu);
        break;
      case "ASIN":
        setDataProductos(finalFilteredDataForSubmenu);
        break;
      default:
        setDataAdgroups([]);
        setDataCampaign([]);
        setDataPortfolios([]);
        setDataProductos([]);
    }
  }, [
    copiesRealTime,
    selectedNegativeOption,
    activeSubmenuFilter,
    submenuSearchValue,
  ]);

  const formatCSTsJSON = async () => {
    const selectedItems = Object.keys(temporaryCheckboxes[getCurrentTypeKey()])
      .map((itemId) =>
        tableData.find((item) => item.id.toString() === itemId.toString()),
      )
      .filter((item) => item !== undefined);

    if (selectedItems.length === 0) {
      alertify.notify(
        "No items selected to negativize.",
        "warning",
        5,
      );
      return false;
    }

    const itemsGroupedByReport = selectedItems.reduce((acc, item) => {
      const reportId = item.originalReportId;
      if (!acc[reportId]) {
        acc[reportId] = [];
      }
      acc[reportId].push(item);
      return acc;
    }, {});

    try {
      for (const reportId in itemsGroupedByReport) {
        const itemsForThisReport = itemsGroupedByReport[reportId];
        const groupedByModalidad = {};

        let reportSpecificCopyData = copyData.filter(
          (d) => d.originalReportId === reportId,
        );

        for (const item of itemsForThisReport) {
          const checkboxData =
            temporaryCheckboxes[getCurrentTypeKey()][item.id];
          let modalidad;
          if (checkboxData.color === "naranja") {
            modalidad =
              selectedNegativeOption === "Adgroup" ? 1 : selectedNegativeOption === "Campaign" ? 4 : selectedNegativeOption === "Portfolio" ? 7 : selectedNegativeOption === "ASIN" ? 10 : null;
          } else if (checkboxData.color === "azul") {
            modalidad =
              selectedNegativeOption === "Adgroup" ? 2 : selectedNegativeOption === "Campaign" ? 5 : selectedNegativeOption === "Portfolio" ? 8 : selectedNegativeOption === "ASIN" ? 11 : null;
          } else if (checkboxData.color === "morado") {
            modalidad =
              selectedNegativeOption === "Adgroup" ? 3 : selectedNegativeOption === "Campaign" ? 6 : selectedNegativeOption === "Portfolio" ? 9 : selectedNegativeOption === "ASIN" ? 12 : null;
          }

          if (!groupedByModalidad[modalidad])
            groupedByModalidad[modalidad] = [];

          const cstData = {
            reportId: reportId,
            type: item.sponsoredTypeName || "Unknown",
            section: item?.section?.sectionName || "Unknown",
            campaign: {
              campaignId: item?.campaign?.campaignId,
              campaignName: item?.campaign?.campaignName,
            },
            adGroup: {
              adGroupId: item?.adGroup?.adGroupId,
              adGroupName: item?.adGroup?.adGroupName,
            },
            targeting: item.keyword || "Unknown",
            matchType: item.keywordType || "Unknown",
            cst: item.searchTerm || "Unknown",
          };

          console.log(cstData);

          const errorMessage = generarDestiny(
            cstData,
            modalidad,
            item,
            item.id,
          );
          if (errorMessage) {
            alertify.notify(errorMessage, "error", 7);
            throw new Error(errorMessage);
          }

          const itemIndexInCopy = reportSpecificCopyData.findIndex(
            (d) => d.id === item.id,
          );
          if (itemIndexInCopy !== -1) {
            reportSpecificCopyData[itemIndexInCopy] = {
              ...reportSpecificCopyData[itemIndexInCopy],
              modalidad: modalidad,
              searchTerm: item.searchTerm,
            };
          }

          groupedByModalidad[modalidad].push(cstData);
        }

        const bodyArray = Object.keys(groupedByModalidad).map((modalidad) => ({
          modalidad: parseInt(modalidad, 10),
          csts: groupedByModalidad[modalidad],
        }));

        bodyArray.accountId = localStorage.getItem("selectedAccountValue");

        if (
          currentUserRole === 1 ||
          currentUserRole === 2 ||
          currentUserRole === 3
        ) {
          await segmentationCSTsByModeNegativization(bodyArray);
          await updateReportAPI(reportSpecificCopyData, reportId);
        } else {
          alertify.notify("You do not have permission to negativize", "error", 5);
          return false;
        }
      }

      alertify.notify("Negativization completed.", "success", 5);
      return true;
    } catch (error) {
      console.error("Error during negativization:", error);
      if (!error.message.includes("No destination selected")) {
        alertify.notify(
          "An error occurred while processing negativization.",
          "error",
          5,
        );
      }
      return false;
    }
  };

  const handleCheckboxChange = (cstId, id) => {
    setSelectedCheckboxes((prev) => {
      return {
        ...prev,
        [cstId]: {
          ...prev[cstId],
          [id]: !prev[cstId][id],
        },
      };
    });
  };

  const handleCSTClick = (cstId) => setCurrentCST(cstId);

  const handlePageClick = ({ selected }) => setCurrentPage(selected);

  const handleItemsPerPageChange = (event) => {
    const newItemsPerPage =
      event.target.value === "todos" ? filteredData.length : parseInt(event.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(0);
  };

  const selectAllAdgroups = (cstId) => {
    setSelectedCheckboxes((prev) => {
      const newState = { ...prev };
      if (!newState[cstId]) newState[cstId] = {};

      if (selectedNegativeOption === "Adgroup") {
        dataAdgroups.forEach((campaign) => {
          campaign.adGroups.forEach(
            (adgroup) => (newState[cstId][adgroup.adGroupId] = true),
          );
        });
      } else if (selectedNegativeOption === "Campaign") {
        dataCampaign.forEach((campaign) => {
          newState[cstId][campaign.campaignId] = true;
        });
      } else if (selectedNegativeOption === "Portfolio") {
        dataPortfolios.forEach((portafolio) => {
          newState[cstId][portafolio.portfolioId] = true;
        });
      } else if (selectedNegativeOption === "ASIN") {
        dataProductos.forEach((producto) => {
          newState[cstId][producto.adId] = true;
        });
      }
      return newState;
    });
  };

  const handleSaveIndividualCST = (itemId) => {
    const updatedData = tableData.map((item) =>
      item.id === itemId ? { ...item, searchTerm : editedCSTs[itemId] || item.searchTerm }
        : item,
    );
    setTableData(updatedData);
    setEditingCSTIds((prev) => prev.filter((id) => id !== itemId));
    setEditedCSTs((prev) => {
      const newEditedCSTs = { ...prev };
      delete newEditedCSTs[itemId];
      return newEditedCSTs;
    });
  };

  const handleDateChange = (event) => {
    setStartDate(event.target.value);
    if (!isRange) {
      setEndDate(event.target.value);
    }
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const columnasSponsoredProducts = React.useMemo(
    () => [
      { label: "Date", value: "date" },
      { label: "Section", value: "Section" },
      { label: "ASIN", value: "ASIN" },
      { label: "Portfolio", value: "Portfolio" },
      { label: "Campaign", value: "Campaign" },
      { label: "adGroup", value: "adGroup" },
      { label: "Targeting", value: "Targeting" },
      { label: "Match Type", value: "Match Type" },
      { label: "CST", value: "CST" },
      { label: "Impressions", value: "Impressions" },
      { label: "Clicks", value: "Clicks" },
      { label: "Cost Per Click", value: "Cost Click" },
      { label: "Spend", value: "Spend" },
      { label: "7D Sales", value: "7D Sales" },
      { label: "Units Sold", value: "Units Sold" },
      { label: "CTR", value: "CTR" },
      { label: "ACOS", value: "ACOS" },
      { label: "ROAS", value: "ROAS" },
    ],
    [],
  );

  const columnasSponsoredBrands = React.useMemo(
    () => [
      { label: "Date", value: "date" },
      { label: "Section", value: "Section" },
      { label: "ASIN", value: "ASIN" },
      { label: "Portfolio", value: "Portfolio" },
      { label: "Campaign", value: "Campaign" },
      { label: "adGroup", value: "adGroup" },
      { label: "Targeting", value: "Targeting" },
      { label: "Match Type", value: "Match Type" },
      { label: "CST", value: "CST" },
      { label: "Impressions", value: "Impressions" },
      { label: "Clicks", value: "Clicks" },
      { label: "Cost Per Click", value: "Cost Click" },
      { label: "Spend", value: "Spend" },
      { label: "View CTR", value: "View CTR" },
    ],
    [],
  );

  const handleTypeChange = React.useCallback(
    async (typeId) => {
      setSelectedTypeId(typeId);
      setCurrentCST(null);
      setTableData([]);
      setCopyData([]);
      setSearchTerm("");
      setFiltrosAplicados((prevFiltros) => {
        const columnasValidas =
          typeId === 1 ? columnasSponsoredProducts : columnasSponsoredBrands;
        const nuevosFiltros = {};
        for (const key in prevFiltros) {
          if (columnasValidas.some((c) => c.value === key)) {
            nuevosFiltros[key] = prevFiltros[key];
          }
        }
        return nuevosFiltros;
      });
      setSelectedOption(null);
      try {
        alertify.notify("Loading reports", "warning", 5);
        const accountID = localStorage.getItem("selectedAccountValue");
        const parseReportDataField = (rawValue) => {
          try {
            let parsed =
              typeof rawValue === "string" ? JSON.parse(rawValue) : rawValue;

            if (typeof parsed === "string") {
              parsed = JSON.parse(parsed);
            }

            if (Array.isArray(parsed)) return parsed;
            if (Array.isArray(parsed?.data)) return parsed.data;
            return [];
          } catch {
            return [];
          }
        };

        let allData = [];
        let currentDay = moment(startDate);
        const lastDay = moment(endDate);

        while (currentDay.isSameOrBefore(lastDay)) {
          const dateStr = currentDay.format("YYYY-MM-DD");
          const response = await getDailyReport(dateStr, accountID);
          const dailyData = Array.isArray(response?.data) ? response.data : [];
          console.log("getDailyReport response for " + dateStr + ":", dailyData);

          const matchingCandidates = dailyData
            .filter((item) => item.sponsored_type_id === typeId)
            .sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0));

          let matchingItem = null;
          let parsedData = [];

          for (const candidate of matchingCandidates) {
            const candidateData = parseReportDataField(candidate.report_data);

            if (!matchingItem) {
              matchingItem = candidate;
              parsedData = candidateData;
            }

            if (candidateData.length > 0) {
              matchingItem = candidate;
              parsedData = candidateData;
              break;
            }
          }

          console.log("Matched item for typeId " + typeId + ":", matchingItem);

          if (matchingItem && parsedData.length > 0) {
            const dataWithDate = parsedData.map((item) => ({
              ...item,
              date: dateStr,
              id: item.id + "-" + dateStr,
              originalReportId: matchingItem.id,
              sponsored_type_id: typeId,
            }));
            allData = allData.concat(dataWithDate);
          }
          currentDay.add(1, "days");
        }

        if (allData.length === 0) {
          setIsEmpty(true);
          alertify.notify(
            "No reports in selected dates for this sponsored type",
            "error",
            5,
          );
          setTableData([]);
          setCopyData([]);
          if (isProductInfoActive) {
            fetchAmazonProductData(allData);
          }
        } else {
          setIsEmpty(false);
          const updatedData = allData.map((item) => {
            if (item.modalidad) {
              const modalidadInfo = getModalidadInfo(item.modalidad);
              return {
                ...item,
                isNegative: true,
                negativeVisual: modalidadInfo,
              };
            }
            return item;
          });

          const otherTypeData = allLoadedData.current.filter(
            (d) => d.sponsored_type_id !== typeId,
          );
          allLoadedData.current = [...otherTypeData, ...updatedData];

          setTableData(updatedData);
          setCopyData(updatedData);
          alertify.notify("Reports loaded", "success", 5);
          if (isProductInfoActive) {
            fetchAmazonProductData(updatedData);
          }
        }
      } catch (error) {
        alertify.notify("Error fetching daily report", "error", 5);
        console.error("Error fetching daily report:", error);
        setTableData([]);
        setCopyData([]);
      }
    },
    [
      startDate,
      endDate,
      isProductInfoActive,
      fetchAmazonProductData,
      columnasSponsoredBrands,
      columnasSponsoredProducts,
    ],
  );

  useEffect(() => {
    if (!startDate || !endDate) return;
    allLoadedData.current = [];
    handleTypeChange(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, isRange]);

  const clearAllAdgroups = (cstId) => {
    setSelectedCheckboxes((prev) => {
      const newState = { ...prev };
      if (!newState[cstId]) return newState;

      if (selectedNegativeOption === "Adgroup") {
        dataAdgroups.forEach((campaign) => {
          campaign.adGroups.forEach(
            (adgroup) => (newState[cstId][adgroup.adGroupId] = false),
          );
        });
      } else if (selectedNegativeOption === "Campaign") {
        dataCampaign.forEach((campaign) => {
          newState[cstId][campaign.campaignId] = false;
        });
      } else if (selectedNegativeOption === "Portfolio") {
        dataPortfolios.forEach((portafolio) => {
          newState[cstId][portafolio.portfolioId] = false;
        });
      } else if (selectedNegativeOption === "ASIN") {
        dataProductos.forEach((producto) => {
          newState[cstId][producto.adId] = false;
        });
      }
      return newState;
    });
  };

  const modalidadesConfig = {
    Adgroup: "Adgroup",
    Campaign: "Campaign",
    Portfolio: "Portfolio",
    ASIN: "ASIN",
  };

  const modalitySelected = modalidadesConfig[selectedNegativeOption] || "";


  const [columnsToDisplay, setColumnsToDisplay] = useState([
    "Date",
    "Category",
    "Section",
    "ASIN",
    "Portfolio",
    "Campaign",
    "adGroup",
    "Targeting",
    "Match Type",
    "CST",
    "Impressions",
    "Clicks",
    "Cost Per Click",
    "Spend",
  ]);

  const opcionesFiltrado =
    selectedTypeId === 1 ? columnasSponsoredProducts : columnasSponsoredBrands;

  const handleModalidadSelection = (label, color) => {
    setSelectedModalidad(label);
    setSelectedColor(color);
  };

  const handleSelectGrupos = (buttonName) => {
    setSelectedButton(buttonName);
    setColumnsToDisplay([
      "Date",
      "Category",
      "Section",
      "Campaign",
      "adGroup",
      "Targeting",
      "Match Type",
      "CST",
    ]);
  };

  const handleSelectAllGrupos = (buttonName) => {
    setSelectedButton(buttonName);
    setColumnsToDisplay([
      "Date",
      "Category",
      "Section",
      "Targeting",
      "Match Type",
      "CST",
    ]);
  };

  const handleViewOnlySelectedColumns = (buttonName) => {
    setSelectedButton(buttonName);
    setColumnsToDisplay([
      "Date",
      "Category",
      "Section",
      "Campaign",
      "adGroup",
      "Targeting",
      "Match Type",
      "CST",
      "Adgroup per Campaign",
    ]);
  };

  const toggleAdgroup = (campaign) => {
    setIsAdgroupOpen((prev) => ({
      ...prev,
      [campaign]: !prev[campaign],
    }));
  };

  const handleOpenModal = (id) => {
    setItemToRemove(id);
    setIsModalOpen(true);
  };

  const handleConfirmRemove = () => {
    const typeKey = getCurrentTypeKey();

    if (itemToRemove) {
      setTemporaryCheckboxes((prev) => {
        const updatedTypeData = { ...prev[typeKey] };
        delete updatedTypeData[itemToRemove];

        return {
          ...prev,
          [typeKey]: updatedTypeData,
        };
      });
    }

    setIsModalOpen(false);
  };

  const handleCancelRemove = () => {
    setIsModalOpen(false);
  };

  const handleViewCSTClick = () => {
    if (!isViewCSTMode) {
      setOriginalColumns(columnsToDisplay);
      setSelectedButton(`${modalitySelected} Respective`);
      handleSelectGrupos(`${modalitySelected} Respective`);
      setCurrentPage(0);
    }
    setIsViewCSTMode(!isViewCSTMode);
  };

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showCancelModal1, setShowCancelModal1] = useState(false);
  const [showConfirmModal1, setShowConfirmModal1] = useState(false);
  const [editingCSTIds, setEditingCSTIds] = useState([]);
  const [invitado, setInvitado] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);

  const openConfirmModal = () => setShowConfirmModal(true);
  const openConfirmModal1 = () => setShowConfirmModal1(true);
  const openCancelModal = () => setShowCancelModal(true);
  const openCancelModal1 = () => setShowCancelModal1(true);

  const closeModals = () => {
    setShowConfirmModal(false);
    setShowCancelModal(false);
  };

  const closeModals1 = () => {
    setShowConfirmModal1(false);
    setShowCancelModal1(false);
  };

  const confirmSave = async () => {
    const noError = await formatCSTsJSON();
    if (!noError) return;
    const typeKey = getCurrentTypeKey();

    setSavedCheckboxes((prev) => ({
      ...prev,
      [typeKey]: {
        ...prev[typeKey],
        ...temporaryCheckboxes[typeKey],
      },
    }));

    setTemporaryCheckboxes((prev) => ({
      ...prev,
      [typeKey]: {},
    }));

    setSelectedCheckboxes({});
    setIsNegativeMode(false);
    setShowConfirmModal(false);
    setIsViewCSTMode(false);
    setColumnsToDisplay(originalColumns);
    setIsTableVisible(true);
    setFilteredData(tableData);
    setShowAdgroups(false);
  };

  const confirmSave1 = async () => {
    const noError = await formatCSTsJSON();
    if (!noError) return;

    const typeKey = getCurrentTypeKey();

    setSavedCheckboxes((prev) => ({
      ...prev,
      [typeKey]: {
        ...prev[typeKey],
        ...temporaryCheckboxes[typeKey],
      },
    }));

    setTemporaryCheckboxes((prev) => ({
      ...prev,
      [typeKey]: {},
    }));

    setSelectedCheckboxes({});
    setIsNegativeMode(false);
    setShowConfirmModal1(false);
    setIsViewCSTMode(false);
    setIsTableVisible(true);
    setFilteredData(tableData);
    setShowAdgroups(false);
  };

  const confirmCancel = () => {
    const typeKey = getCurrentTypeKey();

    setTemporaryCheckboxes((prev) => ({
      ...prev,
      [typeKey]: {},
    }));
    setSelectedCheckboxes({});
    setIsNegativeMode(false);
    setShowCancelModal(false);
    setIsViewCSTMode(false);
    setColumnsToDisplay(originalColumns);
    setIsTableVisible(true);
    setFilteredData(tableData);
    setShowAdgroups(false);
  };

  const confirmCancel1 = () => {
    const typeKey = getCurrentTypeKey();

    setTemporaryCheckboxes((prev) => ({
      ...prev,
      [typeKey]: {},
    }));
    setSelectedCheckboxes({});
    setIsNegativeMode(false);
    setShowCancelModal1(false);
    setIsViewCSTMode(false);
    setIsTableVisible(true);
    setFilteredData(tableData);
    setShowAdgroups(false);
  };

  const handleExitViewCSTMode = () => {
    setColumnsToDisplay(originalColumns);
    setIsViewCSTMode(false);
    setIsTableVisible(true);
  };

  const handleSave2 = () => {
    const typeKey = getCurrentTypeKey();

    setTemporaryCheckboxes((prev) => {
      const newState = { ...prev, [typeKey]: { ...prev[typeKey] } };

      Object.keys(selectedCheckboxes).forEach((itemId) => {
        if (selectedCheckboxes[itemId]) {
          newState[typeKey][itemId] = {
            color: selectedColor,
            mode: selectedModalidad,
            legend:
              modeAbbreviations[selectedModalidad.split(" ")[0]] +
              " - " +
              destinationAbbreviations[selectedNegativeOption],
            modalidad: selectedModalidadValue,
            type: selectedNegativeOption,
          };
        }
      });

      return newState;
    });

    setSelectedCheckboxes({});
  };

  const handleAddModalidad = () => {
    if (!selectedModalidadValue) return;
    const updatedData = currentData.map((item) =>
      selectedItems.includes(item.id) ? { ...item, modalidad : selectedModalidadValue }
        : item,
    );
    setFilteredData(updatedData);
    setSelectedItems([]);
  };

  const [showAdgroups, setShowAdgroups] = useState(false);

  const handleCheckboxDChange = (itemId) => {
    if (temporaryCheckboxes[getCurrentTypeKey()][itemId]) return;
    setSelectedCheckboxes((prev) => {
      const newState = {
        ...prev,
        [itemId]: !prev[itemId],
      };
      return newState;
    });
  };

  const modeAbbreviations = { Respective: "R", All: "A", Select: "S" };

  const destinationAbbreviations = {
    Adgroup: "AG",
    Campaign: "CA",
    Portfolio: "PO",
    ASIN: "ASIN",
  };

  const handleNegativizeClick = () => {
    setShowNegativeOptions(true);
    setIsNegativeMode(false);
  };

  const handleNegativeModeSelection = (option) => {
    setSelectedNegativeOption(option);
    setActiveSubmenuFilter({ type: "ALL", value: null });
    setSubmenuSearchValue("");
    const submenuInput = document.getElementById("submenuInput");
    if (submenuInput) {
      submenuInput.value = "";
    }
  };

  const getDataRealTime = React.useCallback((response) => {
    const responseData = response?.data || {};
    const campaignsSource = Array.isArray(responseData.campaigns)
      ? responseData.campaigns
      : [];
    const productsSource = Array.isArray(responseData.productos)
      ? responseData.productos
      : [];
    const portfoliosSource = Array.isArray(responseData.portfolios)
      ? responseData.portfolios
      : [];

    const campaigns = campaignsSource
      .filter((campaign) => campaign.state !== "ARCHIVED")
      .map((campaign) => ({
        ...campaign,
        adGroups: (campaign.adGroups || []).filter(
          (group) => group.state !== "ARCHIVED",
        ),
      }));

    const productos = productsSource
      .map((producto) => ({
        ...producto,
        campaigns: (producto.campaigns || []).filter(
          (campaign) => campaign.state !== "ARCHIVED",
        ),
      }))
      .filter(
        (producto) =>
          producto.campaigns.length > 0 && producto.state !== "ARCHIVED",
      );

    const portafolios = portfoliosSource
      .map((portafolio) => ({
        ...portafolio,
        campaigns: (portafolio.campaigns || []).filter(
          (campaign) => campaign.state !== "ARCHIVED",
        ),
      }))
      .filter(
        (portafolio) =>
          portafolio.campaigns.length > 0 && portafolio.state !== "ARCHIVED",
      );

    const asinMap = new Map();

    productos.forEach((producto) => {
      const { asin, campaigns = [] } = producto;

      if (!asinMap.has(asin)) {
        asinMap.set(asin, { ...producto, campaigns: [...campaigns] });
      }
      else {
        const existente = asinMap.get(asin);
        const campaignIdsExistentes = new Set(
          existente.campaigns.map((c) => c.campaignId),
        );
        campaigns.forEach((campaign) => {
          if (!campaignIdsExistentes.has(campaign.campaignId)) {
            existente.campaigns.push(campaign);
            campaignIdsExistentes.add(campaign.campaignId);
          }
        });
        asinMap.set(asin, existente);
      }
    });

    const resultadoFinal = Array.from(asinMap.values());

    setDataAdgroups(campaigns);
    setDataProductos(resultadoFinal);
    setDataCampaign(campaigns);
    setDataPortfolios(portafolios);
    setCopiesRealTime({
      adgroups: campaigns,
      campaigns: campaigns,
      portafolios: portafolios,
      productos: resultadoFinal,
    });
  }, [
    setDataAdgroups,
    setDataProductos,
    setDataCampaign,
    setDataPortfolios,
    setCopiesRealTime,
  ]);

  const getModalidadInfo = (modalidad) => {
    const modalidadMap = {
      1: { color: "naranja", legend: "R-AG" },
      2: { color: "azul", legend: "A-AG" },
      3: { color: "morado", legend: "S-AG" },
      4: { color: "naranja", legend: "R-CA" },
      5: { color: "azul", legend: "A-CA" },
      6: { color: "morado", legend: "S-CA" },
      7: { color: "naranja", legend: "R-PO" },
      8: { color: "azul", legend: "A-PO" },
      9: { color: "morado", legend: "S-PO" },
      10: { color: "naranja", legend: "R-AS" },
      11: { color: "azul", legend: "A-AS" },
      12: { color: "morado", legend: "S-AS" },
    };
    return modalidadMap[modalidad] || { color: "gris", legend: "N/A" };
  };

  useEffect(() => {
    const fetchLastDate = async () => {
      const accountID = localStorage.getItem("selectedAccountValue");
      if (accountID) {
        try {
          const result = await getLastReportDateAPI(accountID);
          if (result.success && result.lastDate) {
            const lastDate = moment(result.lastDate).format("YYYY-MM-DD");
            console.log("[fetchLastDate] Last report date found:", lastDate);
            setStartDate(lastDate);
            setEndDate(lastDate);
            setReprocessDate(lastDate);
            return;
          }
        } catch (error) {
          console.error("[fetchLastDate] Error:", error);
        }
      }
      // Fallback to yesterday if no last date found or no account
      const fallback = getYesterdayDate();
      console.log("[fetchLastDate] Using fallback date:", fallback);
      setStartDate(fallback);
      setEndDate(fallback);
      setReprocessDate(fallback);
    };
    fetchLastDate();
  }, []);

  useEffect(() => {
    (async () => {
      const accountID = localStorage.getItem("selectedAccountValue");
      const response = await getUpdateData(accountID);
      const currentUser = await getCurrentUser();
      setCurrentUserRole(currentUser.userRolesId);
      setInvitado(currentUserRole === 4);
      getDataRealTime(response);
    })();
  }, [
    setDataAdgroups,
    setDataCampaign,
    setDataPortfolios,
    setCopiesRealTime,
    setDataProductos,
    currentUserRole,
    getDataRealTime,
  ]);

  const notifyBOT = React.useCallback(async () => {
    try {
      await axios.get("https://bot.jungleclick.online");
      console.log("BOT notificado.");
    } catch (error) {
      console.warn("⚠️ Could not notify BOT:", error.message);
    }
  }, []);

  useEffect(() => {
    const handleConnect = () => {
      console.log("OK Connected to WebSocket server:", socket.id);
      notifyBOT();
    };

    const handleUpdate = (data) => {
      console.log("UPDATE Update received:", data);
      const account = localStorage.getItem("selectedAccountValue");
      if (data.data.accountId === account) getDataRealTime({ data : data.data.data });
      else console.log("Update skipped");
    };

    socket.on("connect", handleConnect);
    socket.on("update", handleUpdate);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("update", handleUpdate);
    };
  }, [notifyBOT, getDataRealTime]);

  const [isAdgroupOpen, setIsAdgroupOpen] = useState({});

  const handleSortData = React.useCallback((data, currentSortConfig) => {
    if (!currentSortConfig.key) return data;

    const sortedData = [...data].sort((a, b) => {
      let aValue = getNestedValue(a, currentSortConfig.key);
      let bValue = getNestedValue(b, currentSortConfig.key);

      if (aValue === null || aValue === undefined) aValue = "";
      if (bValue === null || bValue === undefined) bValue = "";

      if (aValue === "" && currentSortConfig.key !== "portfolio.portfolioName")
        aValue = 0;
      if (bValue === "" && currentSortConfig.key !== "portfolio.portfolioName")
        bValue = 0;
      if (aValue === "" && currentSortConfig.key === "portfolio.portfolioName")
        aValue = "No Portfolio";
      if (bValue === "" && currentSortConfig.key === "portfolio.portfolioName")
        bValue = "No Portfolio";

      const isNumericA = !isNaN(parseFloat(aValue)) && isFinite(aValue);
      const isNumericB = !isNaN(parseFloat(bValue)) && isFinite(bValue);

      if (isNumericA && isNumericB) {
        const numA = parseFloat(aValue);
        const numB = parseFloat(bValue);
        return currentSortConfig.direction === "asc" ? numA - numB : numB - numA;
      } else if (isNumericA) {
        return currentSortConfig.direction === "asc" ? -1 : 1;
      } else if (isNumericB) {
        return currentSortConfig.direction === "asc" ? 1 : -1;
      } else {
        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();
        if (aStr < bStr) return currentSortConfig.direction === "asc" ? -1 : 1;
        if (aStr > bStr) return currentSortConfig.direction === "asc" ? 1 : -1;
        return 0;
      }
    });
    return sortedData;
  }, []);

  useEffect(() => {
    let data = tableData;

    if (isViewCSTMode) {
      data = allLoadedData.current;
      const allSaved = { ...savedCheckboxes.SP, ...savedCheckboxes.SB };
      const allTemp = { ...temporaryCheckboxes.SP, ...temporaryCheckboxes.SB };

      data = data.filter((item) => {
        const savedCheckbox = allSaved[item.id] || allTemp[item.id];
        if (!savedCheckbox) return false;

        if (
          selectedButton.includes("Respective") &&
          savedCheckbox.color === "naranja"
        )
          return true;
        else if (
          selectedButton.includes("All") &&
          savedCheckbox.color === "azul"
        )
          return true;
        else if (
          selectedButton.includes("Select") &&
          savedCheckbox.color === "morado"
        )
          return true;
        return false;
      });

      setFilteredData(data);
    } else {
      data = data.filter((item) => {
        let matchFilter = true;
        let seccionFilter = true;
        let portfolioFilter = true;
        let texto = true;
        let numero = true;

        for (const key in filtrosAplicados) {
          const filterValue = filtrosAplicados[key];

          if (key === "Match Type") {
            if (Array.isArray(filterValue) && filterValue.length > 0) {
              matchFilter = filterValue.includes(item?.keywordType || "");
            }
          } else if (key === "Section") {
            if (Array.isArray(filterValue) && filterValue.length > 0) {
              seccionFilter = filterValue.includes(item?.section?.sectionName || "");
            }
          } else if (key === "Portfolio") {
            if (Array.isArray(filterValue) && filterValue.length > 0) {
              const itemPortfolioName =
                item?.portfolio?.portfolioName || "No portfolio";
              portfolioFilter = filterValue.includes(itemPortfolioName);
            }
          } else if (
            ["ASIN", "Campaign", "adGroup", "Targeting", "CST"].includes(key)
          ) {
            if (
              filterValue &&
              typeof filterValue === "object" &&
              filterValue.hasOwnProperty("option") &&
              filterValue.hasOwnProperty("value")
            ) {
              const campos = {
                ASIN: item?.asin || "No ASIN",
                Campaign: item?.campaign?.campaignName || "No campaign",
                adGroup: item?.adGroup?.adGroupName || "No adGroup",
                Targeting: item?.keyword || item?.keywordText || "",
                CST: item?.searchTerm || "",
              };
              const itemValue = String(campos[key] || "")
                .toLowerCase()
                .replaceAll("_", " ")
                .trim();
              const filterText = String(filterValue.value || "")
                .toLowerCase()
                .trim();

              if (filterText === "") {
                continue;
              }

              switch (filterValue.option) {
                case "Contains":
                  texto = texto && itemValue.includes(filterText);
                  break;
                case "No Contains":
                  texto = texto && !itemValue.includes(filterText);
                  break;
                case "Equals":
                  texto = texto && itemValue === filterText;
                  break;
                case "Does Not Equal":
                  texto = texto && itemValue !== filterText;
                  break;
                case "Starts with":
                  texto = texto && itemValue.startsWith(filterText);
                  break;
                case "Ends with":
                  texto = texto && itemValue.endsWith(filterText);
                  break;
                default:
                  break;
              }
            }
          } else if (
            [
              "Impresiones",
              "Clicks",
              "Cost Click",
              "Spend",
              "Sale 7D",
              "Units Sold",
              "CTR",
              "ACOS",
              "ROAS",
            ].includes(key)
          ) {
            if (
              filterValue &&
              typeof filterValue === "object" &&
              filterValue.hasOwnProperty("option") &&
              filterValue.value !== null &&
              filterValue.value !== undefined &&
              filterValue.value !== ""
            ) {
              const campos = {
                Impresiones: item.impressions,
                Clicks: item.clicks,
                "Cost Click": item.costPerClick,
                Spend: item.cost || 0,
                "Sale 7D": item.sales7d || 0,
                "Units Sold": item.unitsSoldClicks7d || 0,
                CTR: item.clickThroughRate || 0,
                ACOS: item.acosClicks7d || 0,
                ROAS: item.roasClicks7d || 0,
              };
              const itemValue = Number(campos[key]);
              const filterNumber = filterValue.value;

              switch (filterValue.option) {
                case "Greater than":
                  numero = numero && itemValue > filterNumber;
                  break;
                case "Equal to":
                  numero = numero && itemValue === filterNumber;
                  break;
                case "Less than":
                  numero = numero && itemValue < filterNumber;
                  break;
                default:
                  break;
              }
            }
          }
        }

        const isSeccionFilterActive =
          Array.isArray(filtrosAplicados["Section"]) &&
          filtrosAplicados["Section"].length > 0;
        const isMatchFilterActive =
          Array.isArray(filtrosAplicados["Match Type"]) &&
          filtrosAplicados["Match Type"].length > 0;
        const isPortfolioFilterActive =
          Array.isArray(filtrosAplicados["Portfolio"]) &&
          filtrosAplicados["Portfolio"].length > 0;

        return (
          (isMatchFilterActive ? matchFilter : true) &&
          (isSeccionFilterActive ? seccionFilter : true) &&
          (isPortfolioFilterActive ? portfolioFilter : true) &&
          texto &&
          numero
        );
      });
      data = handleSortData(data, sortConfig);

      if (searchTerm.trim() !== "") {
        const searchTermLower = searchTerm.toLowerCase();
        data = data.filter((item) => {
          const values = Object.values(item)
            .map((val) => {
              if (val === null || val === undefined) return "";
              if (typeof val === "object") return JSON.stringify(val);
              return String(val);
            })
            .join(" ")
            .toLowerCase();
          return values.includes(searchTermLower);
        });
      }

      setFilteredData(data);
    }
  }, [
    tableData,
    filtrosAplicados,
    sortConfig,
    isViewCSTMode,
    savedCheckboxes,
    selectedButton,
    selectedTypeId,
    searchTerm,
    handleSortData,
    temporaryCheckboxes,
  ]);

  return (
    <Layout>
      <div className="app-containerreportgeneral">
        <div className="mt-3">
          <h2 className="segmentation-history">General reports</h2>
          {isViewCSTMode && (
            <div className="d-flex justify-content-center align-items-center">
              <button
                onClick={() =>
                  handleSelectGrupos(`${modalitySelected} Respective`)
                }
                className={`filter-button2 px-2 py-2 ${selectedButton === `${modalitySelected} Respective` ? "active" : ""}`}
              >
                {modalitySelected} Respective
              </button>

              <button
                onClick={() =>
                  handleSelectAllGrupos(`All ${modalitySelected}`)
                }
                className={`filter-button4 px-2 py-2 ${selectedButton === `All ${modalitySelected}` ? "active" : ""}`}
              >
                All {modalitySelected}
              </button>

              <button
                onClick={() =>
                  handleViewOnlySelectedColumns(
                    `Select ${modalitySelected}`,
                  )
                }
                className={`filter-button1 px-2 py-2 ${selectedButton === `Select ${modalitySelected}` ? "active" : ""}`}
              >
                Select {modalitySelected}
              </button>
            </div>
          )}
          <div className="negative-options-container">
            {showNegativeOptions && (
              <div className="negative-options">
                <h2 className="titulo-negativization">
                  Negativization Mode
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  {["Adgroup", "Campaign", "Portfolio", "ASIN"].map(
                    (option) => (
                      <button
                        key={option}
                        onClick={() => handleNegativeModeSelection(option)}
                        className={`mx-2 my-2 ${selectedNegativeOption === option ? "btn btn-info" : "btn btn-secondary"}`}
                      >
                        By {option}
                      </button>
                    ),
                  )}
                </div>
                <div className="confirmation-buttons">
                  <button
                    onClick={() => {
                      if (selectedNegativeOption) {
                        setIsNegativeMode(true);
                        setShowNegativeOptions(false);
                      } else {
                        alert(
                          "Please select an option before confirming.",
                        );
                      }
                    }}
                    className="btn btn-success"
                    disabled={!selectedNegativeOption}
                  >
                    Confirm
                  </button>

                  <button
                    onClick={() => {
                      setSelectedNegativeOption("");
                      setShowNegativeOptions(false);
                      setIsNegativeMode(false);
                    }}
                    className="btn btn-danger"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="filter-controls2">
            <div className="botones1">
              {!isViewCSTMode && isNegativeMode && (
                <div className="general-report-page-container1 px-0">
                  <div className="modalidad-neg mb-0">
                    <h2>Negativization Modality</h2>
                    <div className="modalidad-buttons">
                      {(() => {
                        let modalidadButtons = [];

                        switch (selectedNegativeOption) {
                          case "Adgroup":
                            modalidadButtons = [
                              {
                                label: "Respective Adgroup",
                                color: "naranja",
                                value: 1,
                              },
                              {
                                label: "All Adgroups",
                                color: "azul",
                                value: 2,
                              },
                              {
                                label: "Select Ad Groups",
                                color: "morado",
                                value: 3,
                              },
                            ];
                            break;
                          case "Campaign":
                            modalidadButtons = [
                              {
                                label: "Respective Campaign",
                                color: "naranja",
                                value: 4,
                              },
                              {
                                label: "All Campaigns",
                                color: "azul",
                                value: 5,
                              },
                              {
                                label: "Select Campaigns",
                                color: "morado",
                                value: 6,
                              },
                            ];
                            break;
                          case "Portfolio":
                            modalidadButtons = [
                              {
                                label: "Respective Portfolio",
                                color: "naranja",
                                value: 7,
                              },
                              {
                                label: "All Portfolios",
                                color: "azul",
                                value: 8,
                              },
                              {
                                label: "Select Portfolios",
                                color: "morado",
                                value: 9,
                              },
                            ];
                            break;
                          case "ASIN":
                            modalidadButtons = [
                              {
                                label: "Respective ASIN",
                                color: "naranja",
                                value: 13,
                              },
                              {
                                label: "All ASINs",
                                color: "azul",
                                value: 14,
                              },
                              {
                                label: "Select ASINs",
                                color: "morado",
                                value: 15,
                              },
                            ];
                            break;
                          default:
                            break;
                        }

                        if (!selectedModalidad && modalidadButtons.length > 0) {
                          handleModalidadSelection(
                            modalidadButtons[0].label,
                            modalidadButtons[0].color,
                            modalidadButtons[0].value,
                          );
                        }

                        return modalidadButtons.map(
                          ({ label, color, value }) => (
                            <button
                              key={label}
                              className={`px-4 py-1 mx-2 fs-5 btn modalidad-button ${color} ${
                                selectedModalidad === label ? "selected" : "not-selected"
                              }`}
                              value={value}
                              onClick={() => {
                                handleModalidadSelection(label, color);
                                setSelectedModalidadValue(value);
                              }}
                            >
                              {label}
                            </button>
                          ),
                        );
                      })()}
                    </div>
                  </div>
                </div>
              )}
              {!isViewCSTMode && (
                <div className="table-switch-buttons">
                  <h5 className="fs-6 text-center mt-2 mx-3">
                    {" "}
                    Select a Sponsored Type:
                  </h5>
                  <button
                    className="btn btn-secondary mx-2"
                    onClick={() => {
                      handleTypeChange(1);
                    }}
                  >
                    Sponsored Products
                  </button>
                  <button
                    className="btn btn-secondary mx-2"
                    onClick={() => {
                      handleTypeChange(2);
                    }}
                  >
                    Sponsored Brands
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="horizontal-container">
            <div className="center-section justify-content-center flex-column">
              <div className="d-flex w-100">
                <div className="buscador-container flex-grow-1">
                  {isViewCSTMode ? (
                    <button
                      onClick={handleExitViewCSTMode}
                      className="btn btn-primary ms-3 py-2"
                    >
                      <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                  ) : (
                    <></>
                  )}

                  <input style={{ maxWidth : "500px" }}
                    type="text"
                    id="text-busqueda"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="form-control"
                  />

                  <div className="col-md-3 d-flex align-items-center">
                    <input
                      type="date"
                      id="dateFilter"
                      className="form-control"
                      value={startDate || ""}
                      onChange={handleDateChange}
                      max={getYesterdayDate()}
                    />
                    {isRange && (
                      <>
                        <span className="mx-2">a</span>
                        <input
                          type="date"
                          id="endDateFilter"
                          className="form-control"
                          value={endDate || ""}
                          onChange={handleEndDateChange}
                          min={startDate || ""}
                          max={getYesterdayDate()}
                        />
                      </>
                    )}
                  </div>

                  <div className="form-check ms-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={isRange}
                      onChange={(e) => setIsRange(e.target.checked)}
                      id="range-checkbox"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="range-checkbox"
                    >
                      Range
                    </label>
                  </div>

                  <div style={{ minWidth: "250px" }}>
                    <Select
                      options={opcionesFiltrado}
                      placeholder="Filter by..."
                      isSearchable
                      onChange={handleSelectChange}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          backgroundColor: "#ffeeba",
                          border: "1px solid #e0a800",
                          boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(255, 193, 7, 0.25)" : null,
                          "&:hover": {
                            borderColor: "#e0a800",
                          },
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          color: "#212529",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: "#212529",
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected ? "#ffeeba" : "#fff",
                          color: state.isSelected ? "#000" : "#212529",
                        }),
                      }}
                    />
                  </div>

                  <Modal style={{ zIndex : 10000 }}
                    show={showModal}
                    onHide={() => {
                      setShowModal(false);
                      setCurrentMultipleSelection([]);
                    }}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Filter by: {modalTitle}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <div className="d-flex flex-column gap-2">
                        {modalOptions.map((opcion, i) => (
                          <div className="form-check" key={i}>
                            <input
                              className="form-check-input border border-1 border-dark"
                              type="checkbox"
                              name="filtro-opcion-multiple"
                              id={`checkbox-${i}`}
                              value={opcion}
                              checked={currentMultipleSelection.includes(
                                opcion,
                              )}
                              onChange={() => handleMultiSelectChange(opcion)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`checkbox-${i}`}
                            >
                              {opcion}
                            </label>
                          </div>
                        ))}
                      </div>
                    </Modal.Body>

                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => {
                          setShowModal(false);
                          setCurrentMultipleSelection([]);
                        }}
                      >
                        Close
                      </Button>
                      <Button variant="primary" onClick={handleApplyFilter}>
                        Apply
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <Modal style={{ zIndex : 10000 }}
                    show={showTextFilterModal}
                    onHide={() => setShowTextFilterModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        {modalTitle} - Text Filter:{" "}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Select
                        options={textFilterOptions.map((option) => ({
                          label: option,
                          value: option,
                        }))}
                        value={{
                          label: selectedTextFilterOption,
                          value: selectedTextFilterOption,
                        }}
                        onChange={(selectedOption) =>
                          setSelectedTextFilterOption(selectedOption.value)
                        }
                      />
                      <input
                        type="text"
                        className="form-control mt-3"
                        value={textFilterValue}
                        onChange={(e) => setTextFilterValue(e.target.value)}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowTextFilterModal(false)}
                      >
                        Cancel
                      </Button>
                      <Button variant="primary" onClick={handleApplyTextFilter}>
                        Apply
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <Modal style={{ zIndex : 10000 }}
                    show={showNumberFilterModal}
                    onHide={() => setShowNumberFilterModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        {modalTitle} - Numeric Filter:{" "}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Select
                        options={numberFilterOptions.map((option) => ({
                          label: option,
                          value: option,
                        }))}
                        value={{
                          label: selectedNumberFilterOption,
                          value: selectedNumberFilterOption,
                        }}
                        onChange={(selectedOption) =>
                          setSelectedNumberFilterOption(selectedOption.value)
                        }
                      />
                      <input
                        type="number"
                        className="form-control mt-3"
                        value={numberFilterValue || ""}
                        onChange={(e) => setNumberFilterValue(e.target.value)}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowNumberFilterModal(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        onClick={handleApplyNumberFilter}
                      >
                        Apply
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <Modal
                    show={showReprocessModal}
                    onHide={() => setShowReprocessModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Reprocess reports</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="form-group mb-3">
                        <label>Select process type:</label>
                        <select
                          className="form-control"
                          value={reprocessType}
                          onChange={(e) => {
                            setReprocessType(e.target.value);
                          }}
                        >
                          <option value="partial">Partial Process (Re-format existing data — fast, no API call)</option>
                          <option value="full">Full Process (Fetch fresh data from Amazon Ads — ~3–5 min)</option>
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Select date:</label>
                        <input
                          type="date"
                          className="form-control"
                          max={getYesterdayDate()}
                          value={reprocessDate}
                          onChange={(e) => setReprocessDate(e.target.value)}
                        />
                      </div>
                      
                      <div className="alert alert-warning mt-3 mb-0" style={{ fontSize: "0.85rem" }}>
                        <strong>⚠️ Important:</strong> It is recommended to process <strong>only one date at a time</strong> per account. Amazon may block or delay requests if multiple simultaneous processes are detected.
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowReprocessModal(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        onClick={async () => {
                          try {
                            setShowReprocessModal(false);
                            console.log(
                              "Reprocesar:",
                              reprocessType,
                              reprocessDate,
                            );
                            const accountID = localStorage.getItem(
                              "selectedAccountValue",
                            );
                            await processReportsAPI(
                              accountID,
                              reprocessDate,
                              reprocessType,
                            );
                            if (reprocessType === "full") {
                              alertify.success(
                                "Full process started for " + reprocessDate + ". Track progress in the 🔔 notification area."
                              );
                            } else {
                              alertify.success(
                                "Partial process completed for " + reprocessDate
                              );
                            }
                          } catch (error) {
                            console.error("Error al procesar el reporte:", error);
                            alertify.error(error.message || "Error during reprocessing");
                          }
                        }}
                      >
                        Process
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  {!isNegativeMode ? (
                    <>
                      <button
                        disabled={isEmpty || invitado}
                        onClick={handleNegativizeClick}
                        className="btn btn-primary ms-3 py-2"
                      >
                        Negativize
                      </button>

                      <div className="text-end mb-3 d-flex justify-content-end align-items-center">
                        <div className="text-center">
                          <button
                            className="btn btn-warning"
                            onClick={() => setShowReprocessModal(true)}
                          >
                            Reprocess reports
                          </button>
                        </div>
                        <button className={`btn ${isProductInfoActive ? "btn-success" : "btn-secondary"} ms-2`}
                          onClick={() =>
                            setIsProductInfoActive((prev) => !prev)
                          }
                          style={{ minWidth: "150px" }}
                        >
                          Product Info:{" "}
                          {isProductInfoActive ? "Active" : "Inactive"}
                        </button>
                      </div>
                    </>
                  ) : !isViewCSTMode ? (
                    <button
                      disabled={invitado}
                      onClick={handleViewCSTClick}
                      className="btn btn-secondary"
                    >
                      {isViewCSTMode ? (
                        <FontAwesomeIcon icon={faArrowRotateLeft} />
                      ) : (
                        "Ver CST"
                      )}
                    </button>
                  ) : (
                    <></>
                  )}

                  {isNegativeMode && (
                    <div className="button-container d-flex justify-content-center align-items-center ms-2">
                      {!isViewCSTMode && (
                        <button
                          disabled={invitado}
                          onClick={handleSave2}
                          className="btn btn-primary"
                        >
                          Add
                        </button>
                      )}
                      {isViewCSTMode && (
                        <button
                          onClick={openCancelModal}
                          className="btn btn-danger"
                        >
                          <FontAwesomeIcon icon={faXmark} />
                        </button>
                      )}
                      {!isViewCSTMode && (
                        <button
                          onClick={openCancelModal1}
                          className="btn btn-danger"
                        >
                          <FontAwesomeIcon icon={faXmark} />
                        </button>
                      )}
                      {!isViewCSTMode && (
                        <button
                          onClick={openConfirmModal1}
                          className="btn btn-success"
                        >
                          <i className="bi bi-check-lg"></i>
                        </button>
                      )}
                      {isViewCSTMode && (
                        <button
                          onClick={openConfirmModal}
                          className="btn btn-success"
                        >
                          <i className="bi bi-check-lg"></i>
                        </button>
                      )}

                      {showConfirmModal && (
                        <div className="modal">
                          <div className="modal-content">
                            <div className="">
                              <p>Do you want to confirm this negativization</p>
                              <button
                                onClick={() => {
                                  confirmSave();
                                  closeModals();
                                  handleAddModalidad();
                                }}
                                className="btn btn-success mx-2"
                              >
                                Confirm
                              </button>
                              <button
                                onClick={closeModals}
                                className="btn btn-danger mx-2"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {showConfirmModal1 && (
                        <div className="modal">
                          <div className="modal-content">
                            <div className="">
                              <p>Do you want to confirm this negativization</p>
                              <button
                                onClick={() => {
                                  confirmSave1();
                                  closeModals1();
                                  handleAddModalidad();
                                }}
                                className="btn btn-success mx-2"
                              >
                                Confirm
                              </button>
                              <button
                                onClick={closeModals1}
                                className="btn btn-danger mx-2"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {showCancelModal1 && (
                        <div className="modal">
                          <div className="modal-content">
                            <div className="">
                              <p>Do you want to cancel this negativization</p>
                              <button
                                onClick={() => {
                                  confirmCancel1();
                                  closeModals1();
                                }}
                                className="btn btn-success mx-2"
                              >
                                Yes, cancel
                              </button>
                              <button
                                onClick={closeModals1}
                                className="btn btn-danger mx-2"
                              >
                                No
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {showCancelModal && (
                        <div className="modal">
                          <div className="modal-content">
                            <div className="">
                              <p>Do you want to cancel this negativization</p>
                              <button
                                onClick={() => {
                                  confirmCancel();
                                  closeModals();
                                }}
                                className="btn btn-success mx-2"
                              >
                                Yes, cancel
                              </button>
                              <button
                                onClick={closeModals}
                                className="btn btn-danger mx-2"
                              >
                                No
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex gap-2 flex-wrap my-3 w-100 justify-content-start">
                {Object.entries(filtrosAplicados).map(([key, value]) => {
                  let displayValue = "";
                  if (Array.isArray(value)) {
                    if (value.length === 0) return null;
                    displayValue = value.join(", ");
                  } else if (
                    typeof value === "object" &&
                    value !== null &&
                    value.hasOwnProperty("option") &&
                    value.hasOwnProperty("value")
                  ) {
                    if (
                      value.value === "" ||
                      value.value === null ||
                      value.value === undefined
                    )
                      return null;
                    displayValue = `${value.option} ${value.value}`;
                  } else if (value !== null && value !== undefined) {
                    displayValue = String(value);
                  } else {
                    return null;
                  }

                  return (
                    <span
                      key={key}
                      className="badge bg-primary text-white d-flex align-items-center gap-2 px-3 py-2 rounded-pill"
                    >
                      {key}: {displayValue}
                      <button
                        className="btn btn-sm btn-light border-0"
                        style={{
                          lineHeight: "1",
                          padding: "0.2rem 0.4rem",
                          fontSize: "0.8rem",
                        }}
                        onClick={() => {
                          const nuevo = { ...filtrosAplicados };
                          delete nuevo[key];
                          setFiltrosAplicados(nuevo);
                        }}
                      >
                        x
                      </button>
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
          {isTableVisible && (
            <div className="container-fluid">
              <div
                className="row px-0 mx-0" key={isViewCSTMode ? "cst-mode" : "normal-mode"}
              >
                <table className={`report-table px-0 ${columnsToDisplay.includes("Adgroup per Campaign") ? "col-7" : "col-12"} border border-1 border-dark px-2 py-2`}
                >
                  <thead>
                    <tr>
                      {columnsToDisplay.includes("Date") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("date")}
                          style={{ cursor: "pointer" }}
                        >
                          Date
                          {sortConfig.key === "date" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("Category") && (
                        <th className="px-2 py-2">Category</th>
                      )}
                      {columnsToDisplay.includes("Section") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("section.sectionName")}
                          style={{ cursor: "pointer" }}
                        >
                          Section
                          {sortConfig.key === "section.sectionName" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("ASIN") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("asin")}
                          style={{ cursor: "pointer" }}
                        >
                          ASIN
                          {sortConfig.key === "asin" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("Portfolio") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("portfolio.portfolioName")}
                          style={{ cursor: "pointer" }}
                        >
                          Portfolio
                          {sortConfig.key === "portfolio.portfolioName" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("Campaign") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("campaign.campaignName")}
                          style={{ cursor: "pointer" }}
                        >
                          Campaign
                          {sortConfig.key === "campaign.campaignName" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("adGroup") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("adGroup.adGroupName")}
                          style={{ cursor: "pointer" }}
                        >
                          adGroup
                          {sortConfig.key === "adGroup.adGroupName" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("Targeting") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("keyword")}
                          style={{ cursor: "pointer" }}
                        >
                          Targeting
                          {sortConfig.key === "keyword" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("Match Type") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("keywordType")}
                          style={{ cursor: "pointer" }}
                        >
                          Match Type
                          {sortConfig.key === "keywordType" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("CST") && (
                        <th
                          className={`highlight-${selectedModalidad}`}
                          onClick={() => handleSort("searchTerm")}
                          style={{ cursor: "pointer" }}
                        >
                          CST
                          {sortConfig.key === "searchTerm" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("Impressions") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("impressions")}
                          style={{ cursor: "pointer" }}
                        >
                          Impressions
                          {sortConfig.key === "impressions" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("Clicks") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("clicks")}
                          style={{ cursor: "pointer" }}
                        >
                          Clicks
                          {sortConfig.key === "clicks" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("Cost Per Click") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("costPerClick")}
                          style={{ cursor: "pointer" }}
                        >
                          Cost Per Click
                          {sortConfig.key === "costPerClick" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {columnsToDisplay.includes("Spend") && (
                        <th
                          className="px-2 py-2"
                          onClick={() => handleSort("cost")}
                          style={{ cursor: "pointer" }}
                        >
                          Spend
                          {sortConfig.key === "cost" && (
                            <span className="mx-1">
                              {sortConfig.direction === "asc" ? "^" : "v"}
                            </span>
                          )}
                        </th>
                      )}
                      {selectedTypeId === 1 &&
                        columnsToDisplay.includes("Clicks") && (
                          <>
                            <th
                              className="px-2 py-2"
                              onClick={() => handleSort("sales7d")}
                              style={{ cursor: "pointer" }}
                            >
                              Sales 7D
                              {sortConfig.key === "sales7d" && (
                                <span className="mx-1">
                                  {sortConfig.direction === "asc" ? "^" : "v"}
                                </span>
                              )}
                            </th>
                            <th
                              className="px-2 py-2"
                              onClick={() => handleSort("unitsSoldClicks7d")}
                              style={{ cursor: "pointer" }}
                            >
                              Units Sold
                              {sortConfig.key === "unitsSoldClicks7d" && (
                                <span className="mx-1">
                                  {sortConfig.direction === "asc" ? "^" : "v"}
                                </span>
                              )}
                            </th>
                            <th
                              className="px-2 py-2"
                              onClick={() => handleSort("clickThroughRate")}
                              style={{ cursor: "pointer" }}
                            >
                              CTR
                              {sortConfig.key === "clickThroughRate" && (
                                <span className="mx-1">
                                  {sortConfig.direction === "asc" ? "^" : "v"}
                                </span>
                              )}
                            </th>
                            <th
                              className="px-2 py-2"
                              onClick={() => handleSort("acosClicks7d")}
                              style={{ cursor: "pointer" }}
                            >
                              ACOS
                              {sortConfig.key === "acosClicks7d" && (
                                <span className="mx-1">
                                  {sortConfig.direction === "asc" ? "^" : "v"}
                                </span>
                              )}
                            </th>
                            <th
                              className="px-2 py-2"
                              onClick={() => handleSort("roasClicks7d")}
                              style={{ cursor: "pointer" }}
                            >
                              ROAS
                              {sortConfig.key === "roasClicks7d" && (
                                <span className="mx-1">
                                  {sortConfig.direction === "asc" ? "^" : "v"}
                                </span>
                              )}
                            </th>
                          </>
                        )}
                      {selectedTypeId === 2 &&
                        columnsToDisplay.includes("Clicks") && (
                          <th className="px-2 py-2">View CTR</th>
                        )}
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.length > 0 ? (
                      currentData.map((item) => {
                        const savedCheckbox =
                          temporaryCheckboxes[getCurrentTypeKey()][item.id];
                        if (isViewCSTMode && !savedCheckbox) return null;
                        return (
                          <tr key={item.id}>
                            {columnsToDisplay.includes("Date") && (
                              <td className="px-1 py-1">{item.date}</td>
                            )}
                            {columnsToDisplay.includes("Category") && (
                              <td className="px-1 py-1">
                                {item.sponsoredTypeName}
                              </td>
                            )}
                            {columnsToDisplay.includes("Section") && (
                              <td
                                className={
                                  item?.section?.sectionName === "SECURE" ? "bg-success" : item?.section?.sectionName === "NEUTRAL" ? "bg-warning" : item?.section?.sectionName === "RISK" ? "bg-danger" : "bg-secondary"
                                }
                              >
                                {item?.section?.sectionName || "Undefined"}
                              </td>
                            )}
                            {columnsToDisplay.includes("ASIN") && (
                              <td className="px-1 py-2">{item?.asin || "N/A"}</td>
                            )}
                            {columnsToDisplay.includes("Portfolio") && (
                              <td className="px-1 py-2">
                                {(item?.portfolio?.portfolioName || "No Portfolio").replaceAll(
                                  "_",
                                  " ",
                                )}
                              </td>
                            )}
                            {columnsToDisplay.includes("Campaign") && (
                              <td className="px-1 py-2">
                                {(item?.campaign?.campaignName || "No Campaign").replaceAll(
                                  "_",
                                  " ",
                                )}
                              </td>
                            )}
                            {columnsToDisplay.includes("adGroup") && (
                              <td className="px-1 py-2">
                                {(item?.adGroup?.adGroupName || "No Ad Group").replaceAll(
                                  "_",
                                  " ",
                                )}
                              </td>
                            )}
                            {columnsToDisplay.includes("Targeting") &&
                              selectedTypeId === 1 && (
                                <td className="px-1 py-2">
                                  {item.keyword || item.keywordText}
                                </td>
                              )}
                            {columnsToDisplay.includes("Targeting") &&
                              selectedTypeId === 2 && (
                                <td className="px-1 py-2">
                                  {item.keywordText || item.keyword}
                                </td>
                              )}
                            {columnsToDisplay.includes("Match Type") && (
                              <td className="px-1 py-2">
                                {[
                                  "TARGETING_EXPRESSION",
                                  "TARGETING_EXPRESSION_PREDEFINED",
                                ].includes(item.keywordType) ? "-" : (item.keywordType || "-").replaceAll("_", " ")}
                              </td>
                            )}
                            {columnsToDisplay.includes("CST") && (
                              <td
                                className={`${
                                  isViewCSTMode ? "" : savedCheckboxes[getCurrentTypeKey()][
                                          item.id
                                        ] ||
                                        temporaryCheckboxes[getCurrentTypeKey()][
                                          item.id
                                        ] ? `highlight-${savedCheckboxes[getCurrentTypeKey()][item.id].color || temporaryCheckboxes[getCurrentTypeKey()][item.id].color} opacity-50` : item.negativeVisual ? `highlight-${item.negativeVisual.color} opacity-50` : selectedCheckboxes[item.id] ? `highlight-${selectedColor}` : ""
                                }`.trim()}
                              >
                                <div className="cell-content align-items-center justify-content-center">
                                  {isViewCSTMode &&
                                  selectedButton.includes("Select") ? (
                                    isEditingCST &&
                                    editingCSTIds.includes(item.id) ? (
                                      <div className="cst-edit-container">
                                        <input
                                          type="text"
                                          value={editedCSTs[item.id]}
                                          onChange={(e) =>
                                            setEditedCSTs((prev) => ({
                                              ...prev,
                                              [item.id]: e.target.value,
                                            }))
                                          }
                                          className="form-control"
                                        />
                                        <button
                                          onClick={() =>
                                            handleSaveIndividualCST(item.id)
                                          }
                                          className="bg-transparent"
                                        >
                                          <i className="bi bi-check-lg text-success rounded-5 px-2 mx-1 py-1"></i>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        <button
                                          className="btn btn-primary px-1 py-1"
                                          onClick={() => {
                                            setShowAdgroups(true);
                                            handleCSTClick(item.id);
                                          }}
                                        >
                                          <span
                                            className="text-dark text-center mx-1" style={{ fontSize : "13px" }}
                                          >
                                            {item.searchTerm}
                                          </span>
                                        </button>
                                        <button
                                          onClick={() => {
                                            if (
                                              !editingCSTIds.includes(item.id)
                                            ) {
                                              setEditingCSTIds((prev) => [
                                                ...prev,
                                                item.id,
                                              ]);
                                            }
                                          }}
                                          className="bg-transparent"
                                        >
                                          {/*<i className="bi bi-pencil px-2 py-1 rounded-5 text-warning"></i>*/}
                                        </button>
                                      </>
                                    ) ) : (
                                    <>
                                      {isEditingCST &&
                                      editingCSTIds.includes(item.id) ? (
                                        <div className="cst-edit-container">
                                          <input
                                            type="text"
                                            value={
                                              editedCSTs[item.id] !== undefined ? editedCSTs[item.id] : item.searchTerm
                                            }
                                            onChange={(e) =>
                                              setEditedCSTs((prev) => ({
                                                ...prev,
                                                [item.id]: e.target.value,
                                              }))
                                            }
                                            className="form-control"
                                          />
                                          <button
                                            onClick={() =>
                                              handleSaveIndividualCST(item.id)
                                            }
                                            className="bg-transparent"
                                          >
                                            <i className="bi bi-check-lg text-success rounded-5 px-2 mx-1 py-1"></i>
                                          </button>
                                        </div>
                                      ) : isProductInfoActive ? (
                                        <span className="cst-text text-center mx-2">
                                          {(() => {
                                            const targetAsin =
                                              getEffectiveAsin(item);
                                            return (
                                              <ProductInfo
                                                asin={targetAsin}
                                                cst={item.searchTerm}
                                                productData={
                                                  targetAsin
                                                    ? amazonProductsCache[
                                                        targetAsin
                                                      ]
                                                    : null
                                                }
                                                isLoading={
                                                  targetAsin &&
                                                  !amazonProductsCache[targetAsin]
                                                }
                                              />
                                            );
                                          })()}
                                        </span>
                                      ) : (
                                        <span className="cst-text text-center mx-2">
                                          {item.searchTerm}
                                        </span>
                                      )}

                                      {isEditingCST &&
                                        isViewCSTMode &&
                                        !editingCSTIds.includes(item.id) && (
                                          <button
                                            onClick={() => {
                                              if (
                                                !editingCSTIds.includes(item.id)
                                              ) {
                                                setEditingCSTIds((prev) => [
                                                  ...prev,
                                                  item.id,
                                                ]);
                                              }
                                            }}
                                            className="bg-transparent"
                                          >
                                            {/*<i className="bi bi-pencil px-2 py-1 rounded-5 text-warning"></i>*/}
                                          </button>
                                        )}
                                    </>
                                  )}
                                  {isViewCSTMode ? (
                                    <button
                                      className="remove-button mx-2"
                                      onClick={() => handleOpenModal(item.id)}
                                    >
                                      <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                  ) : (
                                    <>
                                      {isNegativeMode && !item.negativeVisual && (
                                        <label className="checkbox-container mx-2">
                                          <input
                                            type="checkbox"
                                            checked={
                                              !!savedCheckboxes[
                                                getCurrentTypeKey()
                                              ][item.id] ||
                                              !!selectedCheckboxes[item.id] ||
                                              !!temporaryCheckboxes[
                                                getCurrentTypeKey()
                                              ][item.id]
                                            }
                                            onChange={() =>
                                              handleCheckboxDChange(item.id)
                                            }
                                            className={`border border-1 border-dark mx-1 form-check-input checkbox-${savedCheckboxes[getCurrentTypeKey()]?.[item.id]?.color || selectedColor}`}
                                            disabled={
                                              !!savedCheckboxes[
                                                getCurrentTypeKey()
                                              ][item.id]
                                            }
                                          />
                                        </label>
                                      )}
                                      {!isViewCSTMode && (
                                        <span className="legend-text">
                                          {savedCheckboxes[getCurrentTypeKey()]?.[item.id]?.legend ||
                                            temporaryCheckboxes[getCurrentTypeKey()]?.[item.id]?.legend ||
                                            item.negativeVisual?.legend ||
                                            (selectedCheckboxes[item.id]
                                              ? `${
                                                  modeAbbreviations[
                                                    selectedModalidad.split(" ")[0]
                                                  ]
                                                } - ${
                                                  destinationAbbreviations[
                                                    selectedNegativeOption
                                                  ]
                                                }`
                                              : "")}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </div>
                              </td>
                            )}
                            {columnsToDisplay.includes("Impressions") && (
                              <td className="px-1 py-2">{item.impressions}</td>
                            )}
                            {columnsToDisplay.includes("Clicks") && (
                              <td className="px-1 py-2">{item.clicks}</td>
                            )}
                            {columnsToDisplay.includes("Cost Per Click") &&
                              selectedTypeId === 1 && (
                                <td className="px-1 py-2">
                                  {item.costPerClick}
                                </td>
                              )}
                            {columnsToDisplay.includes("Cost Per Click") &&
                              selectedTypeId === 2 && (
                                <td className="px-1 py-2">{item.cost}</td>
                              )}
                            {columnsToDisplay.includes("Spend") && (
                              <td className="px-1 py-2">
                                {item.cost != null
                                  ? Number(item.cost).toFixed(2)
                                  : "0.00"}
                              </td>
                            )}

                            {selectedTypeId === 1 &&
                              columnsToDisplay.includes("Clicks") && (
                                <>
                                  <td className="px-1 py-2">{item.sales7d}</td>
                                  <td className="px-1 py-2">
                                    {item.unitsSoldClicks7d}
                                  </td>
                                  <td className="px-1 py-2">
                                    {item.clickThroughRate != null
                                      ? Number(item.clickThroughRate).toFixed(2)
                                      : "0.00"}
                                  </td>
                                  <td className="px-1 py-2">
                                    {item.acosClicks7d != null
                                      ? Number(item.acosClicks7d).toFixed(2)
                                      : "0.00"}
                                  </td>
                                  <td className="px-1 py-2">
                                    {item.roasClicks7d != null
                                      ? Number(item.roasClicks7d).toFixed(2)
                                      : "0.00"}
                                  </td>
                                </>
                              )}
                            {selectedTypeId === 2 &&
                              columnsToDisplay.includes("Clicks") && (
                                <td className="px-1 py-2">
                                  {item.viewClickThroughRate != null
                                    ? Number(item.viewClickThroughRate).toFixed(2)
                                    : "0.00"}
                                </td>
                              )}
                          </tr>
                        );
                      }) ) : (
                      <tr>
                        <td colSpan="18">
                          {isViewCSTMode ? "No selected items to display." : "No data available."}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {columnsToDisplay.includes("Adgroup per Campaign") && (
                  <div
                    className="col-5 px-3 py-2" style={{ overflowY : "scroll", height: "500px" }}
                  >
                    {showAdgroups && (
                      <div
                        className="adgroups-container mt-0 rounded-5 border border-1 border-dark rounded-5" style={{ overflow : "auto" }}
                      >
                        <div className="container">
                          <div className="row my-4">
                            <div className="col-8">
                              <input
                                id="submenuInput"
                                type="text"
                                className="form-control w-100"
                                placeholder="Search..."
                                value={submenuSearchValue}
                                onChange={(e) =>
                                  setSubmenuSearchValue(e.target.value)
                                }
                              />
                            </div>
                            <div className="col-4">
                              <div className="dropdown w-auto">
                                <button
                                  className="btn btn-secondary dropdown-toggle"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  Filter by
                                </button>
                                <ul className="dropdown-menu">
                                  {selectedNegativeOption === "Campaign" ? (
                                    <>
                                      <li
                                        style={{
                                          cursor: "pointer",
                                          margin: "5px",
                                        }}
                                        onClick={() => handleFilterClick("SP")}
                                      >
                                        Type SP
                                      </li>
                                      <li
                                        style={{
                                          cursor: "pointer",
                                          margin: "5px",
                                        }}
                                        onClick={() => handleFilterClick("SB")}
                                      >
                                        Type SB
                                      </li>
                                      <li
                                        style={{
                                          cursor: "pointer",
                                          margin: "5px",
                                        }}
                                        onClick={() =>
                                          handleFilterClick("ENABLED")
                                        }
                                      >
                                        State Enabled
                                      </li>
                                      <li
                                        style={{
                                          cursor: "pointer",
                                          margin: "5px",
                                        }}
                                        onClick={() =>
                                          handleFilterClick("PAUSED")
                                        }
                                      >
                                        State Paused
                                      </li>
                                      <li
                                        style={{
                                          cursor: "pointer",
                                          margin: "5px",
                                        }}
                                        onClick={() => handleFilterClick("ALL")}
                                      >
                                        No Filter
                                      </li>
                                    </>
                                  ) : (
                                    <>
                                      <li
                                        style={{
                                          cursor: "pointer",
                                          margin: "5px",
                                        }}
                                        onClick={() =>
                                          handleFilterClick("ENABLED")
                                        }
                                      >
                                        State Enabled
                                      </li>
                                      <li
                                        style={{
                                          cursor: "pointer",
                                          margin: "5px",
                                        }}
                                        onClick={() =>
                                          handleFilterClick("PAUSED")
                                        }
                                      >
                                        State Paused
                                      </li>
                                      <li
                                        style={{
                                          cursor: "pointer",
                                          margin: "5px",
                                        }}
                                        onClick={() => handleFilterClick("ALL")}
                                      >
                                        No Filter
                                      </li>
                                    </>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>

                        <h4 className="fs-4 text-uppercase text-center my-3">
                          {selectedNegativeOption}
                        </h4>
                        <div className="global-action-buttons">
                          <button
                            className="select-all-button"
                            onClick={() => selectAllAdgroups(currentCST)}
                          >
                            Select all
                          </button>
                          <button
                            className="clear-all-button"
                            onClick={() => clearAllAdgroups(currentCST)}
                          >
                            Clear all
                          </button>
                        </div>

                        {(selectedNegativeOption === "Adgroup" ? dataAdgroups : []
                        ).map((campaign, idx) => (
                          <div
                            className="campaign-container"
                            style={{
                              overflow: "auto",
                              height: "300px",
                            }}
                            key={idx}
                          >
                            <button style={{ fontSize : "14px" }}
                              className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center"
                              onClick={() => toggleAdgroup(campaign.campaignId)}
                            >
                              <span className="float-start">
                                {isAdgroupOpen[campaign.campaignId] ? `v ` : `> `}
                                Campaign: {campaign.name.replaceAll("_", " ")}
                              </span>
                              <span
                                className="float-end text-light ms-2"
                                style={{
                                  fontSize: "11px",
                                  textTransform: "uppercase",
                                }}
                              >
                                State: {campaign.state} <br />
                                Type: {campaign.type}
                              </span>
                            </button>
                            {isAdgroupOpen[campaign.campaignId] && (
                              <div className="adgroup-options">
                                {campaign.adGroups.map((adgroup, index) => (
                                  <div
                                    key={`adgroup-${adgroup.adGroupId}-${index}`}
                                    className="form-control d-flex align-items-center justify-content-evenly"
                                  >
                                    <input
                                      type="checkbox"
                                      className="mx-3"
                                      checked={
                                        selectedCheckboxes[currentCST][
                                          adgroup.adGroupId
                                        ] || false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(
                                          currentCST,
                                          adgroup.adGroupId,
                                        )
                                      }
                                      id={`adgroup-${campaign.campaignId}-${adgroup.adGroupId}-${index}`}
                                    />
                                    <label style={{ fontSize : "14px" }}
                                      htmlFor={`adgroup-${campaign.campaignId}-${adgroup.adGroupId}-${index}`}
                                    >
                                      AdGroup:{" "}
                                      {adgroup.name.replaceAll("_", " ")}
                                    </label>
                                    <span
                                      className="float-end ms-2"
                                      style={{
                                        fontSize: "11px",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      State: {adgroup.state}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                        {(selectedNegativeOption === "Campaign" ? dataCampaign : []
                        ).map((campaign, idx) => (
                          <div
                            className="campaign-container"
                            style={{
                              overflow: "auto",
                              height: "300px",
                            }}
                            key={idx}
                          >
                            <div className="row px-0 mx-0">
                              <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedCheckboxes[currentCST][
                                      campaign.campaignId
                                    ] || false
                                  }
                                  onChange={() =>
                                    handleCheckboxChange(
                                      currentCST,
                                      campaign.campaignId,
                                    )
                                  }
                                  className="form-check-input h-50 w-100 border border-1 border-dark"
                                />
                              </div>
                              <div className="col-11">
                                <button style={{ fontSize : "14px" }}
                                  className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center"
                                  onClick={() =>
                                    toggleAdgroup(campaign.campaignId)
                                  }
                                >
                                  <span className="float-start">
                                    {isAdgroupOpen[campaign.campaignId] ? `v ` : `> `}
                                    Campaign:{" "}
                                    {campaign.name.replaceAll("_", " ")}
                                  </span>
                                  <span
                                    className="float-end text-light ms-2"
                                    style={{
                                      fontSize: "11px",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    State: {campaign.state} <br />
                                    Type: {campaign.type}
                                  </span>
                                </button>
                              </div>
                              <div className="col-12">
                                {isAdgroupOpen[campaign.campaignId] && (
                                  <div className="adgroup-options">
                                    {campaign.adGroups.map((adgroup, index) => (
                                      <div
                                        key={`adgroup-${adgroup.adGroupId}-${index}`}
                                        className="form-control d-flex align-items-center justify-content-evenly"
                                      >
                                        <label style={{ fontSize: "14px" }}>
                                          AdGroup:{" "}
                                          {adgroup.name.replaceAll("_", " ")}
                                        </label>
                                        <span
                                          className="float-end ms-2"
                                          style={{
                                            fontSize: "11px",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          State: {adgroup.state}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                        {(selectedNegativeOption === "Portfolio" ? dataPortfolios : []
                        ).map((portafolio, idx) => (
                          <div
                            className="campaign-container"
                            style={{
                              overflow: "auto",
                              height: "300px",
                            }}
                            key={idx}
                          >
                            <div className="row px-0 mx-0">
                              <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedCheckboxes[currentCST][
                                      portafolio.portfolioId
                                    ] || false
                                  }
                                  onChange={() =>
                                    handleCheckboxChange(
                                      currentCST,
                                      portafolio.portfolioId,
                                    )
                                  }
                                  className="form-check-input h-50 w-100 border border-1 border-dark"
                                />
                              </div>
                              <div className="col-11">
                                <button style={{ fontSize : "14px" }}
                                  className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center"
                                  onClick={() =>
                                    toggleAdgroup(portafolio.portfolioId)
                                  }
                                >
                                  <span className="float-start">
                                    {isAdgroupOpen[portafolio.portfolioId] ? `v ` : `> `}
                                    Portfolio:{" "}
                                    {portafolio.name.replaceAll("_", " ")}
                                  </span>
                                  <span
                                    className="float-end text-light mt-2 ms-2"
                                    style={{
                                      fontSize: "11px",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    State: {portafolio.state} <br />
                                  </span>
                                </button>
                              </div>
                              <div className="col-12">
                                {isAdgroupOpen[portafolio.portfolioId] && (
                                  <div className="adgroup-options">
                                    {portafolio.campaigns.map(
                                      (campaign, index) => (
                                        <div
                                          key={`campaign-${campaign.campaignId}-${index}`}
                                          className="form-control d-flex align-items-center justify-content-evenly"
                                        >
                                          <label style={{ fontSize: "14px" }}>
                                            Campaign:{" "}
                                            {campaign.name.replaceAll("_", " ")}
                                          </label>
                                          <span
                                            className="float-end mx-2 ms-2"
                                            style={{
                                              fontSize: "11px",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            State: {campaign.state}
                                            <br />
                                            Type: {campaign.type}
                                          </span>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                        {(selectedNegativeOption === "ASIN" ? dataProductos : []
                        ).map((producto, idx) => (
                          <div
                            className="campaign-container"
                            style={{
                              overflow: "auto",
                              height: "300px",
                            }}
                            key={idx}
                          >
                            <div className="row px-0 mx-0">
                              <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedCheckboxes[currentCST][
                                      producto.adId
                                    ] || false
                                  }
                                  onChange={() =>
                                    handleCheckboxChange(
                                      currentCST,
                                      producto.adId,
                                    )
                                  }
                                  className="form-check-input h-50 w-100 border border-1 border-dark"
                                />
                              </div>
                              <div className="col-11">
                                <button style={{ fontSize : "14px" }}
                                  className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center"
                                  onClick={() => toggleAdgroup(producto.adId)}
                                >
                                  <span className="float-start">
                                    {isAdgroupOpen[producto.adId] ? `v ` : `> `}
                                    ASIN:{" "}
                                    {typeof producto.asin === "string" &&
                                    (producto.asin.trim() !== "" ? producto.asin.replaceAll("_", " ") : "Unnamed ASIN")}
                                  </span>
                                </button>
                              </div>
                              <div className="col-12">
                                {isAdgroupOpen[producto.adId] && (
                                  <div className="adgroup-options">
                                    {producto.campaigns.map(
                                      (campaign, index) => (
                                        <div
                                          key={`campaign-${campaign.campaignId}-${index}`}
                                          className="form-control d-flex align-items-center justify-content-evenly"
                                        >
                                          <label style={{ fontSize: "14px" }}>
                                            Campaign:{" "}
                                            {campaign.name.replaceAll("_", " ")}
                                          </label>
                                          <span
                                            className="float-end mx-2 ms-2"
                                            style={{
                                              fontSize: "11px",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            State: {campaign.state}
                                            <br />
                                            Type: {campaign.type}
                                          </span>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="d-flex justify-content-center align-items-center mt-5">
            <div className="items-per-page-container mx-4">
              <label>Rows per page:</label>
              <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="todos">All</option>
              </select>
            </div>
            <ReactPaginate
              previousLabel={
                <span className="btn-outline-primary">Previous</span>
              }
              nextLabel={<span className="btn-outline-primary">Next</span>}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName="pagination"
              previousLinkClassName="btn-outline-primary"
              nextLinkClassName="btn-outline-primary"
              activeClassName="active"
              disabledClassName="disabled"
            />
          </div>
        </div>
        {isModalOpen && (
          <div className="modal">
            <div className="modal-content px-1 py-2">
              <h2 className="fs-5 my-3">
                Do you want to remove this item from negativization
              </h2>
              <div className="modal-actions">
                <button
                  onClick={handleConfirmRemove}
                  className="btn btn-success mx-2"
                >
                  Confirm
                </button>
                <button
                  onClick={handleCancelRemove}
                  className="btn btn-danger mx-2"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default GeneralReportPage;



